@if (accountId) {
  <pp-account-subscription
    [ppAccountId]="accountId"
    [ppReadOnly]="isAccountAdmin"
  ></pp-account-subscription>
}
